import { render, staticRenderFns } from "./dap-project-info-panel.vue?vue&type=template&id=da2fe2c4&scoped=true"
import script from "./dap-project-info-panel.vue?vue&type=script&lang=ts"
export * from "./dap-project-info-panel.vue?vue&type=script&lang=ts"
import style0 from "./dap-project-info-panel.vue?vue&type=style&index=0&id=da2fe2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2fe2c4",
  null
  
)

export default component.exports